import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AiOutlinePlus } from "react-icons/ai";

import Button, { Color } from "../../../../../../Form/Button";
import { MD_SIZE_CARD, SM_SIZE_CARD, XS_SIZE_CARD } from "../../util";
import { FillShiftCard } from "./styles";

interface NewShiftProps {
  addNewShift: () => void;
}

const NewShift = (props: NewShiftProps) => {
  const { addNewShift } = props;
  const { t: translate } = useTranslation();

  return (
    <Grid item container xs={XS_SIZE_CARD} sm={SM_SIZE_CARD} md={MD_SIZE_CARD}>
      <FillShiftCard>
        <Button
          customColor={Color.SECONDARY_OUTLINED}
          startIcon={<AiOutlinePlus size={17} />}
          onClick={addNewShift}
        >
          {translate("addAShift")}
        </Button>
      </FillShiftCard>
    </Grid>
  );
};

export default NewShift;
